import errorBoundary from '@ifeng-fe/errorBoundary';
import React from 'react';
import PropTypes from 'prop-types';
// import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import styles from './index.css';

class Layout extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    state = {
        allList: this.props.content?.pageData?.list || [],
        filterList: this.props.content?.pageData?.list || [],
        isSearch: false,
        inputText: '',
        bref: this.props.content?.pageData?.desc || '',
        hasShadow: false,
    };

    searchRef = React.createRef();

    async componentDidMount() {
        let flage = true;

        window.addEventListener('scroll', () => {
            if (this.searchRef.current.getBoundingClientRect().top <= 0 && flage) {
                flage = false;
                this.setState({
                    hasShadow: true,
                });
            }
            if (this.searchRef.current.getBoundingClientRect().top > 1 && !flage) {
                flage = true;
                this.setState({
                    hasShadow: false,
                });
            }
        });
    }

    searchHandle = () => {
        const { inputText, allList } = this.state;
        const filterList = [];

        if (inputText.trim() !== '') {
            allList.map((item) => {
                if (item?.company?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputText.toLocaleLowerCase())) {
                    filterList.push(item);
                }

                return item;
            });
        }

        this.setState({
            filterList,
            isSearch: true,
        });
    };

    changeInput = (event) => {
        const { allList } = this.state;

        if (event.target.value !== '') {
            this.setState({
                inputText: event.target.value,
            });
        } else {
            this.setState({
                isSearch: false,
                inputText: '',
                filterList: allList,
            });
        }
    };

    returnList = () => {
        const { allList } = this.state;

        this.setState({
            filterList: allList,
            inputText: '',
            isSearch: false,
        });
    };

    render() {
        const { filterList, bref, isSearch, inputText, hasShadow } = this.state;
        // const isClient = (window.allData && window.allData.devicetype === 'client') || false;
        const qqShareCofig = {
            title: 'Brand Finance 2023年度中国最具价值品牌500强发布',
            img: 'https://x0.ifengimg.com/ucms/2023_19/6A21BF361B3C2DAFB5CC548F4A17D2792A4DB5B2_size24_w300_h300.jpg',
            desc: '报告深度解读入围品牌现状与未来趋势。凤凰财经作为独家受邀媒体，公布该榜单。',
            cb: () => {},
        };
        // const wxLaunchHackData = {
        //     callAppConfig: {
        //         docType: 'web',
        //         pid: 'https://ishare.ifeng.com/loc/davos500top',
        //         kind: 'share01',
        //     },
        // };

        return (
            <div className={styles.pageBody}>
                {/* <div className={styles.title}>Brand Finance 2023年度中国最具价值品牌500强发布</div> */}
                <div className={`${styles.searchBox} ${hasShadow ? styles.searchBoxShadow : ''}`} ref={this.searchRef}>
                    <div className={styles.search}>
                        <input type="text" onChange={this.changeInput} value={inputText} placeholder="搜索品牌名称" />
                        {inputText && <div className={styles.closeIcon} onClick={this.returnList} />}
                    </div>
                    {isSearch ? (
                        <div onClick={this.returnList} className={styles.searchIcon}>
                            取消
                        </div>
                    ) : (
                        <div onClick={this.searchHandle} className={styles.searchIcon}>
                            搜索
                        </div>
                    )}
                </div>
                {!isSearch ? (
                    <div className={styles.searchBref}>
                        <div className={styles.banner}>{bref}</div>
                    </div>
                ) : (
                    ''
                )}
                <div className={styles.tableList}>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            <tr>
                                <th>2023年排名</th>
                                <th>2022年排名</th>
                                <th>品牌</th>
                                <th className={styles.th3}>2023年度品牌价值(CNY，百万)</th>
                                <th>2023年度评级</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filterList.length > 0 ? (
                                filterList.slice(0, 500).map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.rank23 || ''}</td>
                                            <td>{item.rank22 || ''}</td>
                                            <td>{item.company || ''}</td>
                                            {item.rank23 < 101 ? (
                                                 <><td>{item.money}</td>
                                                 <td>{item.rating23}</td></>
                                            ) : (
                                                <td colSpan={3}>非公开信息</td>
                                            )}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr className={styles.searchInfo}>
                                    <td colSpan={4}>
                                        {inputText ? '您搜索的品牌没有进入榜单' : '抱歉，请您输入品牌名称后再进行搜索'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {/* {!isClient ? (
                    <div className={styles.coypRight}>
                        <img
                            className={styles.coypRightPic}
                            src="https://x0.ifengimg.com/ucms/2023_03/A8384CA2290875323D1832D924AEEA6F8A16ABF2_size11_w690_h80.png"
                        />
                        <WxLaunchHack content={wxLaunchHackData} />
                    </div>
                ) : (
                    ''
                )} */}
                <QQShare content={qqShareCofig} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
